import { Spinner } from '@creditornot/cb-progress';
import * as React from 'react';

import sendErrorReport from 'common/utils/sendErrorReport';
import { AdCampaignForm } from 'modules/campaigns/ad-campaign/components/AdCampaignForm/AdCampaignForm';
import { SpinnerContainer } from 'modules/experience/Experience.styled';

import CampaignError from '../../components/CampaignError';
import { useCampaignModuleContext } from '../../context';
import { useMerchantAdCampaignFormValues } from '../hooks/useMerchantAdCampaignFormValues';
import { useVenueAdCampaignFormValues } from '../hooks/useVenueAdCampaignFormValues';

export const NewAdCampaign = () => {
  const { venues, merchantId, entityType } = useCampaignModuleContext();
  const isVenueLevelCampaign = entityType === 'venue';

  const venueFormValues = useVenueAdCampaignFormValues({ isEnabled: isVenueLevelCampaign });
  const merchantFormValues = useMerchantAdCampaignFormValues({ isEnabled: !isVenueLevelCampaign });

  const { adConfig, freeTrialConfig, defaultValues, submitForm, isLoading, isFormSubmissionLoading } =
    isVenueLevelCampaign ? venueFormValues : merchantFormValues;

  if (isLoading) {
    return (
      <SpinnerContainer data-test-id="spinner">
        <Spinner size="large" />
      </SpinnerContainer>
    );
  }

  if (!adConfig) {
    sendErrorReport(new Error('Ad config not found for campaign'), 'NewAdCampaign', {
      venueIds: venues.map(venue => venue.id),
      merchantId,
      entityType,
    });

    return <CampaignError />;
  }

  return (
    <AdCampaignForm
      adsConfig={adConfig}
      initialValues={defaultValues}
      onSubmit={submitForm}
      isLoading={isFormSubmissionLoading}
      adsFreeTrialConfig={freeTrialConfig}
    />
  );
};
